<template>
  <div class="p-fa-new" >
    <Navigation> </Navigation>
    <Container style=" position: relative;">
      <div class="row">
        <div
          v-if="currentIndex != 5"
          class="col-sm-12 div-text-center"
        >
          <template v-for="(item, idx) in steps">
            <StepButton
              :text="item.text"
              :done="item.done"
              :position="idx"
              :key="idx"
              :active="item.active"
              @click="moveStep"
            />
            <hr v-if="idx != 4" class="line" style="width: 24px; margin-right: 3.5px;" />
          </template>
        </div>
      </div>
      <div class="row">
        <div
          v-if="currentIndex < 5"
          class="col-sm-12 div-text-center"
        >
          <Step1
            v-if="steps[0].active"
            :mENV="outside"
            :cityId="formData.master_city_id"
            :cityName="cityNameStep1"
            :provId="provinceID"
            :provName="provNameStep1"
            @submit:cityID="setFormDataCityID"
            @submit:cityName="setFormDataCityName"
            @submit:provID="setProvID"
            @submit:provName="setProvName"
          />
          <Step2
            v-if="steps[1].active"
            :mENV="outside"
            :mBenefits="formData.benefit_ids"
            :mBenefitNames="benefitNames"
            @submit:benefits="setFormDataBenefits"
            @submit:benefit-names="setBenefitName"
          />
          <Step3
            v-if="steps[2].active"
            :name="formData.name"
            :salutation="formData.salutation"
            @submit:leadName="setFormDataLeadName"
            @submit:salutation="setFormDataSalutation"
          />
          <Step4
            v-if="steps[3].active"
            :salutation="formData.salutation"
            :name="formData.name"
            :phone="formData.mobile_local_number"
            @submit:phone="setFormDataPhone"
          />
          <Step5 
            v-if="steps[4].active"
            @submit:age="setFormDataAge"
            @submit:budget="setFormDataBudget"
            @submit:intended-code="setFormDataIntendedCode"
          />
        </div>
        <div v-if="$route.params.id  == 'thank-you'" class="col-sm-12 div-text-center">
          <SuccessSlate />
        </div>
        <div v-if="$route.params.id  == 'failed'" class="col-sm-12 div-text-center">
          <FailedSlate />
        </div>
      </div>
    </Container>
     <Footer></Footer>
  </div>
</template>

<script>
import Navigation from '../../components/Navigation';
import Container from '../../components/Container';
import Footer from '../../components/Footer';
import StepButton from '../../components/StepButton';
import Step1 from '../../components/find_agent/new/Step1';
import Step2 from '../../components/find_agent/new/Step2';
import Step3 from '../../components/find_agent/new/Step3';
import Step4 from '../../components/find_agent/new/Step4';
import Step5 from '../../components/find_agent/new/Step5';
import SuccessSlate from '../../components/find_agent/new/SuccessSlate';
import FailedSlate from '../../components/find_agent/new/FailedSlate';
import axios from "axios";

export default {
  name: 'FaNew',
  components: {
    Navigation,
    Container,
    Footer,
    StepButton,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    SuccessSlate,
    FailedSlate
  },
  props: ['outside', 'env_ssr'],
  data() {
    return {
      utm_campaign: "", 
      utm_medium: "", 
      utm_source: "",
      currentIndex: 0,
      cityNameStep1: 'Pilih kota',
      success: false,
      failed: false,
      provNameStep1: 'Pilih provinsi',
      benefitNames: [],
      provinceID: null,
      formData: {
        name: '',
        mobile_local_number: '',
        age: null,
        relation_to_ph_code: null,
        budget: null,
        salutation: 'bapak',
        master_city_id: null,
        benefit_ids: [],
      },
      steps: [
        {
          text: 'STEP 1',
          active: true,
          done: false,
        },
        {
          text: 'STEP 2',
          active: false,
          done: false,
        },
        {
          text: 'STEP 3',
          active: false,
          done: false,
        },
        {
          text: 'STEP 4',
          active: false,
          done: false,
        },
        {
          text: 'STEP 5',
          active: false,
          done: false
        }],
    }
  },
  mounted() {
    // if back button is pressed
    var vue = this;
    if (this.$route.query.utm_source || this.$route.query.utm_medium || this.utm_campaign ) {
      this.utm_source = this.$route.query.utm_source;
      this.utm_medium = this.$route.query.utm_medium;
      this.utm_campaign = this.$route.query.utm_campaign;
    }
  
    window.onpopstate = function(event) {
      if (vue.$route.params.id !== '5' && Number(vue.$route.params.id) == vue.currentIndex) {
        vue.currentIndex = Number(vue.$route.params.id) - 1;
        vue.moveStep(vue.currentIndex);
        vue.steps[vue.currentIndex + 1].active = false;
      }
    };

    this.$router.push({ name: 'FaNew' , params: {id: 1}});
  },
  methods: {
    setBenefitName(value) {
      this.benefitNames = value;
    },
    setProvID(value) {
      this.provinceID = value;
    },
    setProvName(value) {
      this.provNameStep1 = value;
    },
    search() {
      this.$router.push({ name: 'FaNew' });
    },
    textStep(text) {
      return null
    },
    setFormDataCityID(cityID) {
      this.formData.master_city_id = cityID;
    },
    setFormDataCityName(cityName) {
      this.cityNameStep1 = cityName;
      this.nextStep();
    },
    nextStep() {
      this.steps[this.currentIndex].active = false;
      this.steps[this.currentIndex].done = true;
      this.steps[this.currentIndex + 1].active = true;
      this.currentIndex += 1;
      this.$router.push({ name: 'FaNew' , params: {id: this.currentIndex + 1}});
    },
    moveStep(idx) {
      if  (this.steps[idx].done == true) {
        this.steps[this.currentIndex].active = false;
        this.currentIndex = idx;
        this.steps[idx].active = true;
        this.$router.push({ name: 'FaNew' , params: {id: idx + 1}});
      }
    },
    setFormDataBenefits(benefits) {
      this.formData.benefit_ids = benefits;
      this.nextStep();
    },
    setFormDataLeadName(leadName) {
      this.formData.name = leadName;
      this.nextStep();
    },
    setFormDataSalutation(salutation) {
      this.formData.salutation = salutation;
    },
    setFormDataPhone(phone) {
      this.formData.mobile_local_number = phone;
      this.nextStep();
    },
    setFormDataAge(age) {
      this.formData.age = age;
    },
    setFormDataBudget(phone) {
      this.formData.budget = phone;
    },
    setFormDataIntendedCode(code) {
      this.formData.relation_to_ph_code = code;
      this.currentIndex = 5;
      this.submitRequest();
    },
    submitRequest() {
      this.formData.master_city_id = Number(this.formData.master_city_id);
      this.formData.budget = Number(this.formData.budget);
      this.formData.age = Number(this.formData.age);
      this.formData.utm_campaign = this.utm_campaign;
      this.formData.utm_source = this.utm_source;
      this.formData.utm_medium = this.utm_medium;
      axios.post('/api_web/fa/leads', this.formData).then((res) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "click_button",
          label: 'complete_form',
          category: 'form',
          province: this.provNameStep1,
          city: this.cityNameStep1,
          protection: this.benefitNames,
          age: this.formData.age,
          budget: this.formData.budget,
          insured: this.formData.relation_to_ph_code
        });
        this.$router.push({ name: 'FaNew' , params: {id: 'thank-you'}});
      }).catch((error) => {
        this.$router.push({ name: 'FaNew' , params: {id: 'failed'}});
      });
     
    }
  }
};
</script>